import usePercentageSupported from './usePercentageSupported';
import useAmountSupported from './useAmountSupported';
var useAmountOrPercentageSupported = function () {
    var percentageSupported = usePercentageSupported();
    var amountSupported = useAmountSupported();
    return percentageSupported || amountSupported;
};
export default useAmountOrPercentageSupported;
